import { RateAndReviewForm } from '../rateAndReviewForm/rateAndReviewForm';
import { RateAndReviewModal } from '../rateAndReviewModal/rateAndReviewModal';
import { canGoBack } from '../rateAndReviewModalVariant';
import type { RateAndReviewModalVariantProps } from '../rateAndReviewModalVariant';
import { RateAndReviewPhaseBody } from '../rateAndReviewPhaseBody/rateAndReviewPhaseBody';
import { ReviewProductHeader } from '../reviewProductHeader/reviewProductHeader';

export type RateAndReviewFormModalProps = RateAndReviewModalVariantProps;

/** A/B test variant A: the modal shell with every question at once. */
export function RateAndReviewFormModal({
  activityOptions,
  brand,
  category,
  errorMessage,
  feelingOptions,
  imageUrl,
  isMobile,
  isRetryable = true,
  isSubmitting,
  moreToReview,
  onBack,
  onChange,
  onRequestClose,
  onReviewProduct,
  onSubmit,
  open,
  productName,
  status = 'editing',
  testId,
  title,
  value,
}: RateAndReviewFormModalProps) {
  return (
    <RateAndReviewModal
      isMobile={isMobile}
      onBack={
        canGoBack({ isRetryable, isSubmitting, status }) ? onBack : undefined
      }
      onRequestClose={onRequestClose}
      open={open}
      productHeader={
        status === 'editing' && (
          <ReviewProductHeader
            brand={brand}
            category={category}
            imageUrl={imageUrl}
            name={productName}
            size="compact"
          />
        )
      }
      testId={testId}
      title={title}
    >
      <RateAndReviewPhaseBody
        errorMessage={errorMessage}
        form={
          <RateAndReviewForm
            activityOptions={activityOptions}
            feelingOptions={feelingOptions}
            isSubmitting={isSubmitting}
            onChange={onChange}
            onSubmit={onSubmit}
            value={value}
          />
        }
        isRetryable={isRetryable}
        isSubmitting={isSubmitting}
        moreToReview={moreToReview}
        onRequestClose={onRequestClose}
        onReviewProduct={onReviewProduct}
        onSubmit={onSubmit}
        productName={productName}
        status={status}
        value={value}
      />
    </RateAndReviewModal>
  );
}
